var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disclosure"},[_c('v-checkbox',{staticClass:"disclosure",attrs:{"id":_vm.id},on:{"change":_vm.onCheckboxChange}}),_c('label',{attrs:{"for":_vm.id}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }